import { useNavigate } from 'react-router-dom';

/**
 * Custom hook that provides navigation functions that keep users within the app
 */
export const useAppNavigation = () => {
  const navigate = useNavigate();

  /**
   * Goes back in history, but if it would take the user outside the app
   * or if there's no history, navigates to the home page instead
   */
  const navigateBack = () => {
    // Check if there's any history by trying to access the history length
    // If the user came from an external site or is on the first page, go to home
    if (window.history.length <= 1) {
      navigate('/');
      return;
    }

    // Try to go back, but if it would leave the app, go to home instead
    const currentOrigin = window.location.origin;
    let hasNavigated = false;

    const handlePopstate = () => {
      if (window.location.origin !== currentOrigin) {
        // If we've left our app, navigate to home
        navigate('/');
      }
      hasNavigated = true;
      window.removeEventListener('popstate', handlePopstate);
    };

    window.addEventListener('popstate', handlePopstate);

    // Go back in history
    window.history.back();

    // Fallback: if navigation didn't happen in 100ms, assume we're on first page
    setTimeout(() => {
      if (!hasNavigated) {
        window.removeEventListener('popstate', handlePopstate);
        navigate('/');
      }
    }, 100);
  };

  return {
    navigateBack,
    navigate, // Still expose the original navigate for other uses
  };
};
